import React from 'react'
import styled from 'styled-components'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const NOCWrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 88vh;
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  h6 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
    margin-top: -10px;
  }
  input {
    margin-top: -20px;
  }
  .amount {
    margin-bottom: 20px;
  }
`
const BvnSettings = () => {
  let location = useLocation()
  return (
    <NOCWrapper>
      <div>
        <h1>BVN Settings</h1>
        <h6>To view the BVN linked to your account, fill in the form below.</h6>
        <div className="amount">
          <h6>Your Security Question is: What is your first gift?</h6>
          <QuicksaveInput type="text" name="Amount" placeholder="" />
        </div>
        <div className="amount">
          <h6>Please type your password here, for security reasons</h6>
          <QuicksaveInput type="text" name="Amount" placeholder="" />
        </div>
      </div>
      <div>
        <Link to={`/big/show-bvn`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Show My BVN</ModalButton>
        </Link>
      </div>
    </NOCWrapper>
  )
}

export { BvnSettings }
